import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useWaveLeaderboardRendererSet } from "../leaderboard/leaderboardRendererRegistry";
interface WaveSmallLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave;
  readonly onDropClick: () => void;
}
export const WaveSmallLeaderboardDrop: React.FC<WaveSmallLeaderboardDropProps> = t0 => {
  const $ = _c(4);
  const {
    drop,
    wave,
    onDropClick
  } = t0;
  const {
    SmallLeaderboardDrop
  } = useWaveLeaderboardRendererSet(wave.id);
  let t1;
  if ($[0] !== SmallLeaderboardDrop || $[1] !== drop || $[2] !== onDropClick) {
    t1 = <SmallLeaderboardDrop drop={drop} onDropClick={onDropClick} />;
    $[0] = SmallLeaderboardDrop;
    $[1] = drop;
    $[2] = onDropClick;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};